import _ from 'lodash';
import React from 'react';

import ExternalLink from 'shared/components/ExternalLink';
import { getUsernameFromUrl } from 'shared/utils/getUsernameFromUrl';
import { getSocialLinks, getVendorWebsite } from './utils';
import { getCompanyLocation } from './utils';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import styles from './styles.module.scss';

const VendorAdditionalLinks = ({ vendor }) => {
  const location = getCompanyLocation(vendor);
  const socialLinks = getSocialLinks(vendor);
  const website = getVendorWebsite(vendor.website);

  return (
    <div className={styles.vendorAdditionalLinksWrapper}>
      <div className={styles.contacts}>
        {!_.isNil(location) && (
          <React.Fragment>
            <div className={styles.contactHeadline}>Location</div>
            <div className={styles.countryInfo}>{location}</div>
          </React.Fragment>
        )}

        <div className={styles.contactHeadline}>Contact</div>
        <div className={styles.contactRow}>
          <div className={styles.contactLabel}>Website</div>
          <div className={styles.websiteLink}>
            <a
              className={styles.contact}
              target="_blank"
              href={website}
              rel="noopener noreferrer">
              {website}
            </a>
          </div>
        </div>

        {socialLinks.shouldRender && (
          <div className={styles.contactRow}>
            <div className={styles.contactLabel}>Social</div>
            <div className={styles.logos}>
              {socialLinks.links.map(item => (
                <ExternalLink href={item.link} key={item.name}>
                  <img
                    src={item.logo}
                    className={styles.socialIcon}
                    alt={item.name}
                  />
                </ExternalLink>
              ))}
            </div>
          </div>
        )}
      </div>
      {vendor.twitter && (
        <div className="standardWidth">
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName={getUsernameFromUrl(vendor.twitter)}
            options={{ height: 400 }}
          />
        </div>
      )}
    </div>
  );
};

export default VendorAdditionalLinks;
